import renderApp from 'mage-app'

import App from './components/App'
import translations from '../translations'

renderApp(App, {
  translations,
  isPublic: true
})
